import { getScope2Emissions } from '../../../api/emissionsApi';
import { getHistoricalReport } from '../../../api/historicalReportsApi';
import { createEmptyScope2, normalizeScope2, normalizeHistoricalScope2 } from '../model/emissionScreens';
import useEmissionScreen from './useEmissionScreen';

export default function useScope2Emissions() {
  return useEmissionScreen({
    request: getScope2Emissions,
    normalize: normalizeScope2,
    createEmpty: createEmptyScope2,
    historicalRequest: getHistoricalReport,
    normalizeHistorical: normalizeHistoricalScope2,
  });
}
